import React from "react";
import { ButtonLoadingContent, loadingButtonClass } from "@/components/buttons/ButtonLoadingContent";
import { Button } from "@/components/ui/button";

interface StackButtonProps {
    primaryButton: string;
    secondaryButton: string;
    handlePrimary?: any;
    handleSecondary?: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    primaryId?: string;
    secondaryId?: string;
    variant?: 'light' | 'primary';
    secondaryVariant?: 'light' | 'primary';
}

const StackButton: React.FC<StackButtonProps> = ({
    primaryId,
    secondaryId,
    primaryButton,
    secondaryButton,
    handlePrimary,
    handleSecondary,
    disabled,
    isLoading,
    variant = 'primary',
    secondaryVariant = 'primary',
}) => {
    return (
        <div className="gs-form-page-actions flex justify-end gap-2">
            <Button
                id={primaryId}
                className={loadingButtonClass(isLoading)}
                variant={variant === 'light' ? 'light' : 'default'}
                onClick={handlePrimary}
                disabled={disabled || isLoading}
                aria-busy={isLoading || undefined}
            >
                <ButtonLoadingContent loading={isLoading} loaderId={primaryId ? `${primaryId}-loader` : undefined}>
                    {primaryButton}
                </ButtonLoadingContent>
            </Button>
            <Button
                id={secondaryId}
                type="button"
                variant="light"
                onClick={handleSecondary}
            >
                {secondaryButton}
            </Button>
        </div>
    );
};

export default StackButton;
